import { render } from "./TravelAnim.vue?vue&type=template&id=6d36639c&scoped=true"
import script from "./TravelAnim.vue?vue&type=script&lang=js"
export * from "./TravelAnim.vue?vue&type=script&lang=js"

import "./TravelAnim.vue?vue&type=style&index=0&id=6d36639c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d36639c"]])

export default __exports__